
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

/* ======================
 * Global Components
 * ======================
 *
 * The following block will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./layouts/noSidebar.vue -> <no-sidebar-layout></no-sidebar-layout>
 */
const layouts1 = require.context("./wrappers", false, /\.vue$/i);
layouts1.keys().map((fileIndexKey) => {
  const componentConfig = layouts1(fileIndexKey);
  const componentName = upperFirst(
    camelCase(fileIndexKey.replace(/^\.\//, "").replace(/\.\w+$/, "")) // .replace(/\w+\//, '')
  ).concat("Layout");

  Vue.component(componentName, componentConfig.default || componentConfig);
});
